<script lang="ts">
  import clsx from 'clsx'
  import { getProgressBarContext } from '../progressBarContext'
  import componentAttributesStore from '../../../../stores/componentAttributes.svelte'
  import { THEMES } from '../../../../const/themes'

  type Props = {
    currentTime: number
    duration: number
    isLive?: boolean
  }

  let { currentTime, duration, isLive = false }: Props = $props()

  const progressBarContext = getProgressBarContext()
</script>

{#if progressBarContext.isDragging || progressBarContext.hoverTime > 0}
  <div
    class={clsx(
      'absolute top-1/2 w-3 h-3 rounded-full transform -translate-x-1/2 -translate-y-1/2',
      {
        'duration-300 ease-linear':
          !progressBarContext.isDragging && progressBarContext.isSmooth,
      },
    )}
    style={`background-color: ${componentAttributesStore.state.progressBarColor || componentAttributesStore.state.primaryColor || THEMES.DEFAULT.PROGRESS_BAR_COLOR}`}
    style:left={`${isLive ? 100 : (currentTime / duration) * 100}%`}
  ></div>
{/if}
